@if (merchantDetails$ | async; as merchant) {
  <ng-container *ngTemplateOutlet="merchantDetails; context: { $implicit: merchant, loading: false }"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="merchantDetails; context: { $implicit: null, loading: true }"></ng-container>
}

<ng-template #merchantDetails [appTemplateContext]="merchantDetailsContext" let-merchant let-loading="loading">
  @if (!loading) {
    <div class="details-page-header-wrapper">
      <div class="page-header">
        <div class="details-page-back-title">
          <a [routerLink]="[pageReturnURL]" class="details-page-back-btn">
            <rkt-icon name="arrow-left" class="details-page-back-btn-icon"></rkt-icon>
          </a>
          <h1 class="details-page-title">
            {{ merchant?.merchantId }}
          </h1>
        </div>
        <app-breadcrumbs [itemList]="breadcrumbs"></app-breadcrumbs>
      </div>
    </div>
  } @else {
    <app-details-page-header-placeholder [pageReturnURL]="pageReturnURL" [withStatus]="false"></app-details-page-header-placeholder>
  }

  <div class="entity-details-container card-account-details-page">
    <div class="details-section-title">
      <div class="title">
        <app-text-with-placeholder [showPlaceholder]="loading">Merchant Details</app-text-with-placeholder>
      </div>
    </div>

    <div class="details-row details-row-with-offset">
      <app-details-item
        [class]="pageClassPrefix + 'id'"
        [showPlaceholder]="loading"
        label="Merchant ID"
        [value]="$safeNavigationMigration(merchant?.merchantId)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'cardAcceptorIdCode'"
        [showPlaceholder]="loading"
        label="Card Acceptor ID Code"
        [value]="$safeNavigationMigration(merchant?.cardAcceptorIdCode)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'merchantCategoryCode'"
        [showPlaceholder]="loading"
        label="Merchant Category Codes"
        [value]="$safeNavigationMigration(merchant?.merchantCategoryCode)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'merchantCategoryDescription'"
        [showPlaceholder]="loading"
        label="Merchant Category Description"
        [value]="$safeNavigationMigration(merchant?.merchantCategoryDescription)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'brandName'"
        [showPlaceholder]="loading"
        label="Brand Name"
        [value]="$safeNavigationMigration(merchant?.brandName)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'dbaName'"
        [showPlaceholder]="loading"
        label="Doing Business As"
        [value]="$safeNavigationMigration(merchant?.dbaName)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'legalName'"
        [showPlaceholder]="loading"
        label="Legal Name"
        [value]="$safeNavigationMigration(merchant?.legalName)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'phone-number'"
        [showPlaceholder]="loading"
        label="Phone Number"
        [value]="$safeNavigationMigration(merchant?.phoneNumber) | phone"
      ></app-details-item>
    </div>

    <div class="details-separator"></div>

    <div class="details-section-title">
      <div class="title"><app-text-with-placeholder [showPlaceholder]="loading">Address</app-text-with-placeholder></div>
    </div>

    <div class="details-row">
      @if (merchant?.merchantAddresses?.length) {
        @for (address of merchant?.merchantAddresses; track address; let i = $index) {
          <app-details-item
            [class]="pageClassPrefix + 'address-' + (i + 1)"
            [showPlaceholder]="loading"
            [label]="'Address ' + (i + 1)"
            [value]="address.address1"
          >
            <ng-container>
              <div>{{ address.address2 }}</div>
              <div>{{ address.city }}, {{ address.state }}</div>
              <div>{{ address.zipCode }} {{ address.countryCode }}</div>
            </ng-container>
          </app-details-item>
        }
      } @else {
        <app-details-item [value]="" [showPlaceholder]="loading"></app-details-item>
      }
    </div>
  </div>
</ng-template>
